import { useState, useEffect, useRef } from "react";

function AnimatedNumber({
  value,
  formatter = (n) =>
    parseFloat(n).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
  duration = 600,
}) {
  const [displayValue, setDisplayValue] = useState(0);
  const prevValueRef = useRef(0);

  useEffect(() => {
    const target = parseFloat(value) || 0;
    const start = prevValueRef.current;
    const startTime = performance.now();

    const easeOutExpo = (t) => (t >= 1 ? 1 : 1 - Math.pow(2, -10 * t));

    const update = (now) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeOutExpo(progress);
      const current = start + (target - start) * eased;
      setDisplayValue(current);
      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        prevValueRef.current = target;
      }
    };
    requestAnimationFrame(update);
  }, [value, duration]);

  return <>{formatter(displayValue)}</>;
}

export default AnimatedNumber;
